import "../tailwind/application"
import "core-js/stable";
import "regenerator-runtime/runtime";
